import { useReducer } from "react";
import api from '../../../../api/organizations';

const intialState = {
  regions: [],
  municipals: []
};

function reducer(state, action) {
  switch (action.type) {
    case "REGIONS":
      return {
        ...state,
        regions: action.regions
      };
    case "MUNICIPALS":
      return {
        ...state,
        municipals: action.municipals
      };
    default:
      return {
        ...state
      };
  }
}

export default function useRoomResourceForm() {
  const [dataSources, dispatch] = useReducer(reducer, intialState);

  function getRegions() {
    api.getRegions().then(({ data }) => {
      dispatch({ type: "REGIONS", regions: data });
    });
  }

  function getMunicipals(id) {
    api.getMunicipals(id).then(({ data }) => {
      dispatch({ type: "MUNICIPALS", municipals: data });
    });
  }

  return {
    dataSources,
    getRegions,
    getMunicipals,
  };
}
